import React from "react";
import { graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Import layout
import Layout from "../layouts/main";

// Import components
import SEO from "../components/seo";

// Import styles
import "./styles/project.scss";
import "./styles/wp-styles.scss";
import "./styles/wpPost.css";

// Import lite youtube embed
import { LiteYouTubeEmbed } from "react-lite-youtube-embed";

// Import gatsby anchor links
import { AnchorLink } from "gatsby-plugin-anchor-links";

// Import icons
import { FaAngleDown } from "@react-icons/all-files/fa/FaAngleDown";
import { FaRegPlayCircle } from "@react-icons/all-files/fa/FaRegPlayCircle";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";

// Import bootstrap
import { Button, Container, Modal } from "react-bootstrap";

const Project = ({ data, pageContext }) => {
  const { wpProject } = data;
  const { previous, next } = pageContext;

  let video = wpProject.projectFields.video;
  let videoUrl = video.replace("https://youtu.be/", "");
  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        className="project-intro-modal"
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-90w"
        centered
      >
        <div
          className="close"
          onClick={props.onHide}
          onKeyDown={props.onHide}
          role="button"
          tabIndex={0}
        >
          <FaTimes />
        </div>
        <LiteYouTubeEmbed
          id={videoUrl}
          title="Test video"
          activeClass="lyt-activated" // Default as "lyt-activated", gives control to wrapper once clicked
          iframeClass="" // Default none, gives control to add a class to iframe element itself
          playerClass="lty-playbtn" // Default as "lty-playbtn" to control player button styles
          wrapperClass="yt-lite" // Default as "yt-lite" for the div wrapping the area, it is the most important class and needs extra attention, please refer to LiteYouTubeEmbed.css for a reference.
        />
      </Modal>
    );
  }
  const [modalShow, setModalShow] = React.useState(false);
  return (
    <Layout>
      <SEO
        title={wpProject.seoFields.seo.title}
        description={wpProject.seoFields.seo.description}
        image={wpProject.featuredImage.node.sourceUrl}
      />
      <div className="project-template">
        <section className="project-intro">
          <div className="overlay" />
          <GatsbyImage
            className="image"
            image={
              wpProject.featuredImage.node.localFile.childImageSharp
                .gatsbyImageData
            }
            alt="test"
          />
          <div className="text">
            <Container>
              <div
                className="play"
                onClick={() => setModalShow(true)}
                onKeyDown={() => setModalShow(true)}
                role="button"
                tabIndex={0}
              >
                <FaRegPlayCircle />
              </div>
              <h1 className="shout">{wpProject.title}</h1>
              <div
                className="talk"
                dangerouslySetInnerHTML={{ __html: wpProject.excerpt }}
              />
              <AnchorLink
                className="btn btn-link stripped"
                to={`/projects/${wpProject.slug}/#project-details`}
                title="Check out details about this project!"
                stripHash
              >
                View Project Details
                <FaAngleDown />
              </AnchorLink>

              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
            </Container>
          </div>
        </section>

        <Container id="project-details" className="post-content">
          <div dangerouslySetInnerHTML={{ __html: wpProject.content }} />
        </Container>
        <Container className="project-pagination">
          <ul>
            <li>
              {previous && (
                <Link to={`/projects/${previous.slug}`} rel="prev">
                  <Button variant="accent">← Prev</Button>
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={`/projects/${next.slug}`} rel="next">
                  <Button variant="accent">Next →</Button>
                </Link>
              )}
            </li>
          </ul>
        </Container>
      </div>
    </Layout>
  );
};

export default Project;

export const query = graphql`
  query WpProjectById($slug: String!) {
    wpProject(slug: { eq: $slug }) {
      __typename
      content
      excerpt
      featuredImage {
        node {
          id
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, formats: AUTO)
            }
          }
          sourceUrl
        }
      }
      projectFields {
        video
      }
      id
      seoFields {
        seo {
          description
          title
        }
      }
      slug
      title
    }
  }
`;
